import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';
import { registerLocaleData } from '@angular/common';
import { environment } from './app/environments/environment';
import localeIt from '@angular/common/locales/it';
registerLocaleData(localeIt);

bootstrapApplication(AppComponent, appConfig)
  .catch((err) => console.error(err));

if ('serviceWorker' in navigator && environment.production) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('ngsw-worker.js').catch(() => {
      // ngsw-worker.js non esiste in dev; ignoriamo il fallimento.
    });
  });
} else if ('serviceWorker' in navigator) {
  navigator.serviceWorker.getRegistrations().then((registrations) => {
    registrations.forEach((registration) => {
      registration.unregister().catch(() => {
        // Ignoriamo errori di cleanup in ambienti non production.
      });
    });
  });
}
